import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Briefcase } from "lucide-react"
import { useEmployeeOnboarding } from "../../employee/hooks/employeeHook"
import EmployeeSelfOnboardingForm from "../components/EmployeeSelfOnboardingForm"
import { Onboardingstatus } from "@/modules/onboarding/onboarding-status"
import { Button } from "@/modules/shared/ui/components/button"

export default function EmployeeOnboardingPage() {
  const { onboardingData, isLoading, loadOnboardingData } =
    useEmployeeOnboarding()
  const location = useLocation()
  const navigate = useNavigate()
  const initialStep =
    (location.state as { initialStep?: number } | null)?.initialStep ?? 0

  useEffect(() => {
    loadOnboardingData()
  }, [loadOnboardingData])

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        Loading...
      </div>
    )
  }

  const isOffboarding =
    onboardingData?.onboardingStatus === Onboardingstatus.OFFBOARDING
  const isTerminated =
    onboardingData?.onboardingStatus === Onboardingstatus.TERMINATED

  if (isOffboarding || isTerminated) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <Briefcase className="w-8 h-8 text-muted-foreground" />
          </div>
          <h2 className="text-lg font-semibold text-foreground">
            Onboarding is closed
          </h2>
          <p className="text-sm text-muted-foreground mt-1 mb-6">
            {isTerminated
              ? "Your employment has ended, so onboarding is no longer available."
              : "You are currently offboarding, so onboarding is no longer available."}
          </p>
          {!isTerminated && (
            <Button
              className="bg-primary hover:bg-primary/90 text-primary-foreground"
              onClick={() => navigate("/employee/offboarding")}
            >
              View Offboarding
            </Button>
          )}
        </div>
      </div>
    )
  }

  return (
    <EmployeeSelfOnboardingForm
      onboardingData={onboardingData}
      initialStep={initialStep}
    />
  )
}
